import React from "react";
import RadioGroupInput from "./RadioGroupInput";
import TextInput from "./TextInput";

const QuestionCard = ({ value, item, error, onChange }) => {
  const { number, description, name, options, questionType, label } = item;

  return (
    <div className="card mb-2">
      <div className="card-header pb-2">
        <div className="form-row">
          <div className="col-12">
            <h6 className="mb-0">
              {number} - {description}
            </h6>
          </div>
        </div>
      </div>
      <div className="card-body pt-2 pb-0">
        {questionType === 1 ? (
          <RadioGroupInput
            key={name}
            name={name}
            options={options}
            value={value}
            onChange={onChange}
          />
        ) : (
          <TextInput
            label={label}
            key={name}
            name={name}
            options={options}
            value={value}
            onChange={onChange}
          />
        )}
        {error && <div className="alert alert-danger mt-1">{error} </div>}
      </div>
    </div>
  );
};

export default QuestionCard;
